import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=a5a78492&"
import script from "./ProfileLayout.vue?vue&type=script&lang=ts&"
export * from "./ProfileLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports